<template>
  <div>
    <div class="analytic-page">
      <div class="tabs-head">
        <router-link :to="'/my-gates/' + currentId + '/analytics'">
          <div class="tabs-head__item activeTab">
            <p>Analytics</p>
          </div>
        </router-link>
        <router-link :to="linkToSettings()">
          <div class="tabs-head__item">
            <p>Settings</p>
          </div>
        </router-link>
      </div>
      <div class="title">
        <h2>Dashboard</h2>
      </div>
      <div class="charts-period">
        <div class="charts-period-title">
          <p>Period</p>
        </div>
        <CustomDropdownBorder
            :options="stat_periods"
            :period="false"
            :days="true"
            :disable-date-after="new Date()"
            :disable-date-before="disableUntilDate()"
            :withDatePicker="true"
            :selected="datePeriod"
            v-on:updateOption="changePeriod"
            :placeholder="'Select an Item'"
            :closeOnOutsideClick="true"
        />
      </div>
      <div class="charts">
        <div v-if="preloadingCharts" class="charts-preloading">
          <Preloader :show-preloader="preloadingCharts"/>
        </div>
        <div class="charts-wrapper d-flex w-100" v-if="!preloadingCharts">
          <div class="doughnut-chart-box">
            <div class="legends-block-wrapper">
              <div class="legends-block d-flex align-items-center justify-content-center">
                <div class="failure-legend">
                  <div class="line"></div>
                  <div class="text">
                    <span>Failure</span>
                  </div>
                </div>
                <div class="success-legend">
                  <div class="line"></div>
                  <div class="text">
                    <span>Success</span>
                  </div>
                </div>
              </div>
            </div>
            <Doughnut
                v-if="get_gate_doughnut_chart[0] + get_gate_doughnut_chart[1] > 0"
                :values="get_gate_doughnut_chart"
                :width="getWidth > 414 ? 360 : 300"
            />
            <div v-if="get_gate_doughnut_chart[0] + get_gate_doughnut_chart[1] === 0"
                 class="empty-doughnut d-flex align-items-center justify-content-center">
                <span>No data</span>
            </div>
            <div class="total-visits-block-wrapper d-flex justify-content-center align-items-center">
              <div class="total-visits-block">
                <p>Total visits: {{get_gate_doughnut_chart[0] + get_gate_doughnut_chart[1]}}</p>
              </div>
            </div>
          </div>
          <div class="line-chart-box">
            <div class="line-chart-box-wrapper"
                 :style="{'width': calculateWidthForLineChart}">
<!--              <pre>-->
<!--                {{get_gate_line_chart}}-->
<!--              </pre>-->
              <LineChart
                  :key="get_gate_line_chart.labels.length"
                  :labels="get_gate_line_chart.labels"
                  :success-values="get_gate_line_chart.success"
                  :failure-values="get_gate_line_chart.failure"
              />
              <div v-if="get_gate_doughnut_chart[0] + get_gate_doughnut_chart[1] === 0"
                   class="empty-line d-flex align-items-center justify-content-center">
                <p>No data</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VisitsTable
          :page_link="getUrl"
          :visits="get_all_visits"
          :available_networks="get_available_networks_for_gate"
          :current_page="get_visits_current_page"
          :total_pages="get_visit_total_pages"
          @export-visits="exportVisits"
          @change-page="get_visits({
            id: $route.params.id,
            date_filter: !!datePeriod.pluck.start ?
              [datePeriod.pluck.start, datePeriod.pluck.end] :
              stat_periods.find(v => v.id === datePeriod.id).pluck,
            page: $event
          })"
      />
    </div>
  </div>
</template>

<script>
import Navigate from "@/components/Navigate/Navigate.vue";
import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue";
import UpdateSettings from "@/views/UpdateSettings/UpdateSettings.vue";
import Preloader from "../../components/Preloader/Preloader.vue";
import NoData from "@/components/__new_ui_kit/Table/NoData";
import LineChart from "@/views/StatisticsPage/charts/LineChart";
import Doughnut from "@/views/StatisticsPage/charts/Doughnut";
import VisitsTable from "@/components/VisitsTable/VisitsTable";
import { mapGetters, mapActions } from "vuex";
import {TAPMIXER_MODE} from "../../utils/variables";

export default {
  name: "StatisticsPage",
  components: {
    VisitsTable,
    Doughnut,
    LineChart,
    CustomDropdownBorder,
    Navigate,
    UpdateSettings,
    Preloader,
    NoData
  },
  data() {
    return {
      preloadingCharts: false,
      currentId: this.$route.params.id,
      currentSocial: this.$route.params.social,
      stat_periods: [
        {id: 0, name: 'All period', pluck: 'all_period'},
        {id: 1, name: 'Today', pluck: 'today'},
        {id: 2, name: 'Yesterday', pluck: 'yesterday'},
        {id: 3, name: 'Last 7 Days', pluck: 'last_7_days'},
        {id: 4, name: 'This Month', pluck: 'this_month'},
        {id: 5, name: 'Last Month', pluck: 'last_month'},
      ],
      datePeriod: {
        id: 4,
        name: 'This Month',
        pluck: 'this_month'
      }
    }
  },
  computed: {
    ...mapGetters([
        'getWidth',
        'get_gate_doughnut_chart',
        'get_gate_line_chart',
        'get_all_visits',
        'get_available_networks_for_gate',
        'get_visits_current_page',
        'get_visit_total_pages',
        'get_all_visits_for_export',
        'toggleSidebar',
        'getContent'
    ]),
    getUrl() {
      return this.getContent.page_url ?
          process.env.VUE_APP_URL + '/' + this.getContent.page_url :
          process.env.VUE_APP_URL + '/' + this.getContent.tag_1 + '-' + this.getContent.tag_2
    },
  },
  watch: {
    datePeriod () {
      this.getStatistics()
    },
    toggleSidebar () {
      this.preloadingCharts = true
      setTimeout(() => {
        this.preloadingCharts = false
      }, 500)
    },
    getWidth () {
      this.preloadingCharts = true
      setTimeout(() => {
        this.preloadingCharts = false
      }, 500)
    }
  },
  created() {
    this.contentById({
      id: this.$route.params.id
    })
    this.getStatistics()
  },
  methods: {
    ...mapActions([
        'get_statistics',
        'get_visits',
        'get_visits_for_export',
        'contentById'
    ]),
    linkToSettings() {
      return process.env.VUE_APP_MODE === TAPMIXER_MODE ? '/my-gates/' + this.currentId + '/settings' : '/my-gates/' + this.currentId + '/' + this.currentSocial + '/settings'
    },
    linkToAnalytics() {
      return process.env.VUE_APP_MODE === TAPMIXER_MODE ? '/my-gates/' + this.currentId + '/analytics' : '/my-gates/' + this.currentId + '/' + this.currentSocial + '/analytics'
    },
    exportVisits () {
      this.get_visits_for_export({
        id: this.$route.params.id,
        date_filter: !!this.datePeriod.pluck.start ?
            [this.datePeriod.pluck.start, this.datePeriod.pluck.end] :
            this.stat_periods.find(v => v.id === this.datePeriod.id).pluck
      }).then(() => {
        let csv = 'data:text/csv;charset=utf-8,' + this.createCSV();
        let excel = encodeURI(csv);

        let link = document.createElement('a');
        link.setAttribute('href', excel);
        link.setAttribute('download', 'users.csv');
        link.click();
      })
    },
    createCSV () {
      let result = '';
      result += 'id,date,result,'
      this.get_available_networks_for_gate.forEach((available_network, index) => {
        result += available_network
        if (index < this.get_available_networks_for_gate.length - 1) {
          result += ','
        }
      })
      result += '\n';
      this.get_all_visits_for_export.forEach(visit => {
        result += visit['id'] + ',' + visit['created_at'].split('T')[0] + ',' + visit['result']
        if (this.get_all_visits_for_export.length > 0) {
          result += ','
        }
        this.get_available_networks_for_gate.forEach((available_network, index) => {
            let available_network_value = visit.networks.find(v => {
              return v.type.toLowerCase() === available_network.toLowerCase() && !!v.user
            })
            result += available_network_value && available_network_value['user']
                ? available_network_value['user']
                : '-'
            if (index < this.get_available_networks_for_gate.length - 1) {
              result += ','
            }
        })
        result += '\n';
      })
      return result;
    },
    changePeriod(v) {
      console.log(v)
      this.datePeriod = v
    },
    getStatistics(visit_page = 1) {
      this.preloadingCharts = true
      this.get_statistics({
        gate_id: this.$route.params.id,
        period: !!this.datePeriod.pluck.start ?
            [this.datePeriod.pluck.start, this.datePeriod.pluck.end] :
            this.stat_periods.find(v => v.id === this.datePeriod.id).pluck
      }).then(() => {
        this.get_visits({
          id: this.$route.params.id,
          date_filter: !!this.datePeriod.pluck.start ?
              [this.datePeriod.pluck.start, this.datePeriod.pluck.end] :
              this.stat_periods.find(v => v.id === this.datePeriod.id).pluck,
          page: visit_page
        }).then(() => {
          this.preloadingCharts = false
        })
      })
    },
    updateTable() {
      this.getStatistics();
    },
    calculateWidthForLineChart () {
      const labels_count = this.get_gate_line_chart.labels.length
      return ((!!this.datePeriod.pluck.start || this.datePeriod.pluck === 'all_period') && labels_count > 32) ?
          labels_count * 36 + 'px' :
          'auto'
    },
    disableUntilDate () {
      if (!!this.getContent.created_at) {
        const date = new Date(this.getContent.created_at.split('T')[0])
        return (date.getMonth() + 1) + '-' + date.getDate() + '-' + date.getFullYear()
      }
      return ''
    }
  }
};
</script>

<style scoped lang="sass">
.analytic-page
  .title
    padding-top: 20px
    h2
      font-family: 'Montserrat', sans-serif
      font-weight: 400
      font-size: 1.5em
  .charts-period
    padding: 20px 0 0 0
    .btn-group
      min-width: 230px
      ::v-deep.mx-datepicker
        width: 100%
    .charts-period-title
      p
        font-weight: 400
        margin-bottom: 10px
    .btn-group
      margin: 0
  .charts
    padding-top: 20px
    .charts-preloading
      height: 476px
      .preloader-wrap
        padding: 0
    .doughnut-chart-box
      width: 25%
      min-width: 360px
      .legends-block-wrapper
        .legends-block
          padding: 12px 0
          margin: 0 0 12px 0
          .failure-legend
            display: flex
            align-items: center
            justify-content: flex-start
            .line
              width: 30px
              height: 3px
              background: #f491ab
              margin-top: 2px
            .text
              line-height: 1
              span
                font-size: 12px
                font-weight: 600
                margin-left: 12px
          .success-legend
            display: flex
            align-items: center
            justify-content: flex-start
            margin-left: 20px
            .line
              width: 30px
              height: 3px
              background: #78bf88
              margin-top: 2px
            .text
              line-height: 1
              span
                font-size: 12px
                font-weight: 600
                font-family: 'Segoe', sans-serif
                margin-left: 12px
      .total-visits-block-wrapper
        min-width: 160px
        width: auto
        .total-visits-block
          margin: 20px auto
          display: inline-flex
          border: 1px solid #279AEA
          padding: 3px 54px
          border-radius: 5px
          p
            color: #279AEA
            font-size: 14px
            line-height: 1.2
    .empty-doughnut
      height: 360px
    .line-chart-box
      margin-top: 40px
      width: 75%
      overflow-x: auto
      .line-chart-box-wrapper
        position: relative
        .empty-line
          width: calc(100% - 30px)
          top: 0
          left: 30px
          position: absolute
          height: 360px
          margin: 12px 0 0 0
.chart-wrapper
  position: relative
  &::v-deep .table-no-data
    max-width: 150px
    position: absolute
    border-bottom: none
    left: 0
    top: 0
    right: 0
    bottom: 0
    margin: auto
.tabs-head
  border-bottom: 1px solid #BDBDBD
  display: flex
  flex-direction: row
  justify-content: flex-start
  padding: 30px 0 0 0
  &__item
    width: 100px
    height: 40px
    display: flex
    align-items: center
    justify-content: center
    margin: 0 10px -1px 0
    border: 1px solid #BDBDBD
    border-radius: 5px 5px 0 0
    cursor: pointer
    p
      color: #777777
      font-weight: 400
  .activeTab
    border-bottom: 1px solid #fff
    p
      color: #454545

@media (max-width: 1025px)
  .analytic-page
    .charts
      .charts-wrapper
        flex-direction: column
      .doughnut-chart-box
        width: 400px
        justify-content: flex-start
      .line-chart-box
        width: 100%
        .line-chart-box-wrapper
          max-width: 100%
@media (max-width: 415px)
  .analytic-page
    .charts
      &-period
        display: flex
        align-items: center
        justify-content: space-between
        .charts-period-title
          margin-right: 10px
          p
            margin-bottom: 0
        .btn-group
          width: 100%
      .charts-wrapper
        flex-direction: column
      .doughnut-chart-box
        width: 300px
        min-width: 300px
        justify-content: flex-start
        margin: auto
      .line-chart-box
        width: 100%
</style>